import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { PARTNERS_QUERIES } from "~/shared/api/partners/partners.queries";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";
import { getSkip } from "~/shared/util/pagination.helpers";
import { getPartnersListSearchParams, PARTNERS_LIST_FILTERS } from "~/team/search-params/partners-list.search-params";
import { MAX_PARTNERS_RESULTS } from "~/team/views/PartnersView/PartnersView.constants";

export async function partnersViewLoader(queryClient: QueryClient, args: LoaderFunctionArgs) {
  const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());

  const searchParams = new URL(args.request.url).searchParams;
  const partnersParams = getPartnersListSearchParams(searchParams);

  const skip = getSkip(partnersParams.page, MAX_PARTNERS_RESULTS);

  const csm = partnersParams.filter === PARTNERS_LIST_FILTERS.CSM ? user.id : undefined;

  const params = {
    skip,
    limit: MAX_PARTNERS_RESULTS,
    ...(partnersParams.term ? { term: partnersParams.term } : {}),
    ...(csm ? { csm } : {}),
  };

  queryClient.prefetchQuery(PARTNERS_QUERIES.partnersList({ params }));

  return null;
}
